import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function OfferStack() {
  const items = [{
    title: 'Guía Maestra: El Código Hormonal 28D',
    value: '$97.00',
    image: 'https://cdn.magicpatterns.com/uploads/iag9TmkkPqHt9rfpmjUPTT/mk-2.png',
    isMain: true
  }, {
    title: 'Bono 1: Recetario "Cocina para tus Hormonas"',
    value: '$47.00',
    image: 'https://cdn.magicpatterns.com/uploads/oKJGkmB9rrETgHjB3nYV6Z/bn-1.png',
    isMain: false
  }, {
    title: 'Bono 2: Calendario Fitness "Ciclo-Sync"',
    value: '$37.00',
    image: 'https://cdn.magicpatterns.com/uploads/oKmRiA6GJEpWwEfxsfGEEY/bn-2.png',
    isMain: false
  }, {
    title: 'Bono 3: Protocolos SOS Anti-Inflamación',
    value: '$27.00',
    image: 'https://cdn.magicpatterns.com/uploads/7dvccXjT6Pkv6779BcnoGy/bn-3.png',
    isMain: false
  }];
  return <section className="py-12 md:py-32 bg-muted-lavender/10" data-id="element-75">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-16" data-id="element-77">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-deep-charcoal mb-4" data-id="element-78">
            El Stack de la Oferta
          </h2>
          <p className="text-xl text-deep-charcoal/80" data-id="element-79">
            Todo esto es lo que recibes hoy por una fracción de su valor real:
          </p>
        </motion.div>

        <div className="space-y-4 md:space-y-6" data-id="element-80">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`bg-white rounded-2xl p-4 sm:p-6 flex flex-col sm:flex-row items-center gap-6 shadow-sm border ${item.isMain ? 'border-dusty-rose shadow-md' : 'border-cream-white'}`} data-id="element-81">
              <div className="w-full sm:w-48 h-36 sm:h-32 flex-shrink-0 rounded-xl overflow-hidden bg-warm-beige relative" data-id="element-82">
                <img src={item.image} alt={item.title} className="absolute inset-0 w-full h-full object-cover" data-id="element-83" />
              </div>

              <div className="flex-grow flex flex-col sm:flex-row items-center sm:items-start justify-between w-full gap-4 text-center sm:text-left" data-id="element-84">
                <div className="flex items-start gap-3" data-id="element-85">
                  <CheckCircle2 className="w-6 h-6 text-sage-green flex-shrink-0 mt-1 hidden sm:block" data-id="element-86" />
                  <div data-id="element-87">
                    {item.isMain && <span className="inline-block px-2 py-1 bg-dusty-rose/10 text-dusty-rose text-xs font-bold rounded mb-2 uppercase tracking-wider" data-id="element-88">
                        Programa Principal
                      </span>}
                    <h3 className="text-lg sm:text-xl font-bold text-deep-charcoal flex items-center justify-center sm:justify-start gap-2" data-id="element-89">
                      <CheckCircle2 className="w-5 h-5 text-sage-green sm:hidden" data-id="element-90" />
                      {item.title}
                    </h3>
                  </div>
                </div>
                <div className="text-right" data-id="element-91">
                  <span className="text-sm text-deep-charcoal/60 uppercase tracking-wider font-semibold block mb-1" data-id="element-92">
                    Valor
                  </span>
                  <span className="text-xl font-bold text-dusty-rose" data-id="element-93">
                    {item.value}
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}